import { render, staticRenderFns } from "./NotionalAccountCardBody.vue?vue&type=template&id=1d3c98f8&scoped=true"
import script from "./NotionalAccountCardBody.vue?vue&type=script&lang=ts"
export * from "./NotionalAccountCardBody.vue?vue&type=script&lang=ts"
import style0 from "./NotionalAccountCardBody.vue?vue&type=style&index=0&id=1d3c98f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3c98f8",
  null
  
)

export default component.exports